import { TweenMax, TimelineMax } from 'gsap';
import React from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFxboost } from '@/components/UI/svg/river2';
import { getImageLocal, getImageSpec } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('');
const ZA_IMG = {
    B1: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711692641744/r2p_b1_1366_za.png',
    B2: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711692649893/r2p_b2_1366_za.png',
};

export default function B() {
    const { useEffect, useLang, useRouter } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['au', 'cn', 'uk', 'de', 'fr', 'es', 'it', 'eu', 'ph']);
    const imgLocalB5 = getImageLocal(locale, ['cn', 'de', 'es', 'fr', 'it', 'jp', 'kr', 'nl', 'cis']);

    let ScrollMagic: any;
    let controller: any;
    useEffect(() => {
        ScrollMagic = (window as any).ScrollMagic;
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        /**
         * @warning 等差动画 未调试
         */
        const originDOM = '.river2_details_B .innerBox';
        // 总运动时长（距离）
        const countDuration = 500;

        const TL = new TimelineMax();
        const chargeBox = TweenMax.to(`${originDOM} .left-box .top`, 0.1, { opacity: 1, ease: undefined });
        const top1 = TweenMax.to(`${originDOM} .right-box .top .left`, 0.1, { y: 0, opacity: 1, ease: undefined });
        const top2 = TweenMax.to(`${originDOM} .right-box .top .right`, 0.1, { y: 0, opacity: 1, ease: undefined });
        const eps_smart = TweenMax.to(`${originDOM} .left-box .bot`, 0.1, { y: 0, opacity: 1, ease: undefined });
        const bot1 = TweenMax.to(`${originDOM} .right-box .bot .left`, 0.1, { y: 0, opacity: 1, ease: undefined });
        const bot2 = TweenMax.to(`${originDOM} .right-box .bot .mid`, 0.1, { y: 0, opacity: 1, ease: undefined });
        const bot3 = TweenMax.to(`${originDOM} .right-box .bot .right`, 0.1, { y: 0, opacity: 1, ease: undefined });

        TL.add(chargeBox, 0).add(top1, 0).add(top2, 0).add(eps_smart, 0).add(bot1, 0).add(bot2, 0).add(bot3, 0);

        const scene = new ScrollMagic.Scene({
            triggerElement: originDOM,
            triggerHook: 1,
            offset: 0,
            duration: countDuration,
        }).setTween(TL);

        controller.addScene(scene);
    }, []);

    return (
        <div className={`river2_details_B ${css.B_2}`}>
            <div className="innerBox">
                <div className="left-box">
                    <div className="top item">
                        <EFPic
                            name={['/media/river2/pc/B1.webp', '/media/river2/pc/B1.png']}
                            alt={t('river2.details.sec2_msg1')}
                            aria-label={t('river2.details.sec2_msg1')}
                        />
                        {!['jp', 'cn', 'tw'].includes(locale) && (
                            <p className="msg1 text">
                                {t.rich('river2.details.sec2_msg1', {
                                    p1: (child: any) => <span className="p1">{child}</span>,
                                    p2: (child: any) => <span className="p2">{child}</span>,
                                    p3: (child: any) => <span className="p3">{child}</span>,
                                    p4: (child: any) => <span className="p4">{child}</span>,
                                })}
                            </p>
                        )}
                        {['cn', 'tw'].includes(locale) && (
                            <div>
                                {t.rich('river2.details.sec2_msg1', {
                                    line1: (child: any) => <div className="cn-p2">{child}</div>,
                                    line2: (child: any) => <div className="cn-p1">{child}</div>,
                                })}
                            </div>
                        )}
                        {locale === 'jp' && (
                            <div>
                                {t.rich('river2.details.sec2_msg1', {
                                    line1: (child: any) => <div className="jp-p2">{child}</div>,
                                    line2: (child: any) => <div className="jp-p1">{child}</div>,
                                })}
                            </div>
                        )}
                    </div>
                    <div className="bot item">
                        {!['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale) && (
                            <div className="left item">
                                <EFPic
                                    name={locale === 'za' ? ZA_IMG.B1 : [`/media/river2/pc/B4_${imgSpec}.webp`, `/media/river2/pc/B4_${imgSpec}.png`]}
                                    alt={t('river2.details.sec2_msg7')}
                                    aria-label={t('river2.details.sec2_msg7')}
                                />
                                <p className="msg2 text">
                                    {t.rich('river2.details.sec2_msg7', {
                                        p2: (child: any) => <span className="p2">{child}</span>,
                                    })}
                                </p>
                            </div>
                        )}
                        <div className="right item">
                            <EFPic
                                name={[`/media/river2/pc/B5_${imgLocalB5}.webp`, `/media/river2/pc/B5_${imgLocalB5}.png`]}
                                alt={t('river2.details.sec2_msg8')}
                                aria-label={t('river2.details.sec2_msg8')}
                            />
                            <p className="msg3 text">{t('river2.details.sec2_msg8')}</p>
                        </div>
                    </div>
                </div>
                <div className="right-box">
                    <div className="top">
                        <div className="left item">
                            <EFPic
                                name={['/media/river2/pc/B2.webp', '/media/river2/pc/B2.png']}
                                alt={t('river2.details.sec2_msg3')}
                                aria-label={t('river2.details.sec2_msg3')}
                            />
                            {!['jp', 'cn'].includes(locale) && (
                                <p className="msg3 text">
                                    {t.rich('river2.details.sec2_msg3', {
                                        p1: (child: React.ReactNode) => <span className="p1">{child}</span>,
                                    })}
                                </p>
                            )}
                            {locale === 'jp' && (
                                <div className="msg3 text">
                                    {t.rich('river2.details.sec2_msg3', {
                                        p1: (child: React.ReactNode) => <div className="jp_p3">{child}</div>,
                                    })}
                                </div>
                            )}
                            {locale === 'cn' && (
                                <div className="msg3 text">
                                    {t.rich('river2.details.sec2_msg3', {
                                        p1: (child: React.ReactNode) => <div className="cn_p">{child}</div>,
                                    })}
                                </div>
                            )}
                        </div>
                        <div className="right item">
                            <EFPic
                                name={['/media/river2/pc/B3.webp', '/media/river2/pc/B3.png']}
                                alt={t('river2.details.sec2_msg4')}
                                aria-label={t('river2.details.sec2_msg4')}
                            />
                            {!['jp'].includes(locale) && (
                                <p className="msg4 text">
                                    {t.rich('river2.details.sec2_msg4', {
                                        p1: (child: any) => <span className="p1">{child}</span>,
                                    })}
                                </p>
                            )}
                            {locale === 'jp' && (
                                <div className="msg4 text">
                                    {t.rich('river2.details.sec2_msg4', {
                                        p1: (child: any) => <div className="jp_p4">{child}</div>,
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="bot">
                        <div className="left item">
                            <EFPic
                                name={
                                    locale === 'ph'
                                        ? 'https://websiteoss.ecoflow.com/upload/image/1752228151521/o1.jpg'
                                        : ['/media/river2/pc/B6.webp', '/media/river2/pc/B6.png']
                                }
                                alt={t('river2.details.sec2_msg5')}
                                aria-label={t('river2.details.sec2_msg5')}
                            />
                            <p className="msg5 text">
                                {t.rich('river2.details.sec2_msg5', {
                                    p1: (child: any) => <span className="p1">{child}</span>,
                                })}
                            </p>
                        </div>
                        <div className="mid item">
                            <EFPic
                                name={
                                    ['jp'].includes(locale)
                                        ? [`/media/river2/pc/B7_${locale}.webp`, `/media/river2/pc/B7_${locale}.png`]
                                        : [`/media/river2/pc/B7.webp`, '/media/river2/pc/B7.png']
                                }
                                alt={t('river2.details.sec2_msg2')}
                                aria-label={t('river2.details.sec2_msg2')}
                            />
                            <p className="msg2 text">
                                <EFxboost />
                            </p>
                        </div>
                        <div className="right item">
                            <EFPic
                                name={
                                    locale === 'ph'
                                        ? 'https://websiteoss.ecoflow.com/upload/image/1751079142505/2.jpg'
                                        : locale === 'za'
                                        ? ZA_IMG.B2
                                        : [`/media/river2/pc/B8_${imgSpec}.webp`, `/media/river2/pc/B8_${imgSpec}.png`]
                                }
                                alt={t('river2.details.sec2_msg6')}
                                aria-label={t('river2.details.sec2_msg6')}
                            />
                            <p className="msg6 text">
                                {t.rich('river2.details.sec2_msg6', {
                                    p1: (child: any) => <span className="p1">{child}</span>,
                                })}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
